// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"2e228c46","418":"c71a2d54","816":"ee02ae78"}[chunkId] + ".js";
};